module.exports = __webpack_public_path__ + "img/bashlogo.8a700b42.png";